import { render, staticRenderFns } from "./SearchOrganisation.vue?vue&type=template&id=18408b3a"
import script from "./SearchOrganisation.vue?vue&type=script&lang=js"
export * from "./SearchOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports